<template>
  <div class="product-list-element">
    <div class="image" :style="style"></div>

    <div class="desc">
      <span
        class="close"
        @click="handleRemoveProduct"
        :data-cart_id="product_data.id"
      ></span>
      <p class="name">{{ product_data.title }}</p>
      <p class="info">
        <input
          @change="handleChangeQuantity($event)"
          name="quantity"
          :value="product_data.quantity"
        />
        <span class="price">{{ product_data.formatted_price }} zł</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductListElement",
  data() {
    return {
      cart_id: null,
      // quantity: 1,

      style: {
        backgroundImage: "none",
      },
    };
  },
  props: {
    product_data: {
      type: Array,
      required: false,
    },
  },
  methods: {
    handleRemoveProduct(e) {
      e.preventDefault();
      this.$emit("remove_cart", { cart_id: this.cart_id });
    },
    handleChangeQuantity(e) {
      console.log(e.target.value);
      this.quantity = e.target.value;
      this.$emit("change_quantity", {
        cart_id: this.cart_id,
        quantity: e.target.value,
      });
    },
  },
  updated() {
    console.log("product updated");
    //this.quantity = this.product_data.quantity;
  },
  created() {
    //this.quantity = this.product_data.quantity;
    this.cart_id = this.product_data.id;
    //console.log('created' + this.product_data.title);
    this.style.backgroundImage = "url('" + this.product_data.img_src + "')";
  },
};
</script>